import useSWR from 'swr';

import { fetchIncomeSources, type IncomeSource } from '../data/incomeSourcesRepository.js';

export const INCOME_SOURCES_KEY = 'income-sources/list';

export type IncomeSourcesState =
  | { status: 'loading' }
  | { status: 'error'; message: string; retry: () => void }
  | { status: 'ready'; sources: readonly IncomeSource[]; refresh: () => Promise<unknown> };

export function useIncomeSources(): IncomeSourcesState {
  const { data, error, isLoading, mutate } = useSWR<readonly IncomeSource[], Error>(
    INCOME_SOURCES_KEY,
    fetchIncomeSources,
    { revalidateOnFocus: false, shouldRetryOnError: false },
  );

  if (error) {
    return {
      status: 'error',
      message: error.message || 'Không tải được danh sách nguồn thu.',
      retry: () => {
        void mutate();
      },
    };
  }

  if (isLoading || !data) return { status: 'loading' };

  return { status: 'ready', sources: data, refresh: () => mutate() };
}
